import React from "react";

const EbookReaderGuide = () => {
  return (
    <div>
      <p>Hello &#128075;</p>
      <p>
        You are probably here because you have been handed an eBook by me. I
        myself personally love the physical books, but its not affordable (and
        yes, money is the only thing stopping me) to buy every book you come
        across, so I like to read half of the book before buying the physical
        copy. and hence, I have a perfect setup for reading eBooks.
      </p>
      <p>
        I recommend you to download Moon+ Reader App -{" "}
        <a href="https://play.google.com/store/apps/details?id=com.flyersoft.moonreader&amp;hl=en&amp;gl=US">
          Play Store Link
        </a>{" "}
      </p>
      <p>
        This app is my personal favorite for reading eBooks, preferably in .epub
        format.
      </p>
      <p>
        I have created a folder called “Books Master” in my mobile devices, and
        all the eBook files are stored in that folder directly. Moon+ Reader
        lets you import the entire folder, and showcases them in a nice looking
        shelf.
      </p>
      <p>
        I personally prefer the default dark mode, with a 15% opacity blue light
        filter, best for your eyes and reading in darkness.
      </p>
      <p>I prefer font size 22 on phone, and 24-25 on tablet.</p>
      <p>
        Moon+ Reader is also great at highlighting text, with multiple colors
        available and a separate menu for managing all the highlighted text.
      </p>
    </div>
  );
};

export default EbookReaderGuide;
